import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Table, Alert, Spinner, Card } from "react-bootstrap";

const FundSummaryReport = () => {
  const [fundSummary, setFundSummary] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch fund summary data
  const fetchFundSummary = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/fund-summary/");
      setFundSummary(response.data);
      setError(null);
    } catch (error) {
      setError(error.response?.data?.detail || "فشل في جلب ملخص الأموال.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFundSummary();
  }, []);

  return (
    <Container style={{ 
      direction: "rtl", 
      textAlign: "right", 
      padding: "20px", 
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      color: "black", 
      backgroundColor: "white" 
    }}>
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>ملخص الصندوق</h1>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Fund Summary Table */
        <Card style={{ padding: "20px", border: "1px solid darkgreen", borderRadius: "5px" }}>
          <h4 style={{ color: "darkgreen" }}>الملخص المالي</h4>
          <Table hover responsive>
            <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
              <tr>
                <th>البند</th>
                <th>القيمة ($)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>إجمالي المشتريات النقدية</td>
                <td>${fundSummary?.total_cach_purchases.toFixed(2)}</td>
              </tr>
              <tr>
                <td>إجمالي المبيعات النقدية</td>
                <td>${fundSummary?.total_cach_sales.toFixed(2)}</td>
              </tr>
              <tr>
                <td>إجمالي مدفوعات العملاء</td>
                <td>${fundSummary?.total_customer_payments.toFixed(2)}</td>
              </tr>
              <tr>
                <td>إجمالي مدفوعات الموردين</td>
                <td>${fundSummary?.total_supplier_payments.toFixed(2)}</td>
              </tr>
              <tr>
                <td>إجمالي المصاريف</td>
                <td>${fundSummary?.total_expenses.toFixed(2)}</td>
              </tr>
              <tr>
                <td>إجمالي تسليمات النقد</td>
                <td>${fundSummary?.total_cash_handovers.toFixed(2)}</td>
              </tr>
            </tbody>
          </Table>
        </Card>
      )}
    </Container>
  );
};

export default FundSummaryReport;